import { render, staticRenderFns } from "./CstmrRegByCstmrComplete.vue?vue&type=template&id=87fb4a7e&"
import script from "./CstmrRegByCstmrComplete.vue?vue&type=script&lang=js&"
export * from "./CstmrRegByCstmrComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports